/**
 * Detecta si la aplicación está corriendo en una Smart TV.
 * Basado en UserAgent y resolución de pantalla.
 */

export const detectTV = () => {
  const ua = navigator.userAgent;

  // Patrones de UserAgent para Smart TVs comunes
  const tvPatterns = [
    /SmartTV/i,
    /AppleTV/i,
    /GoogleTV/i,
    /Tizen/i,        // Samsung Smart TV
    /Web0S/i,        // LG Smart TV (también puede aparecer como WebOS)
    /WebOS/i,
    /NetCast/i,      // LG Smart TV antiguo
    /Opera TV/i,
    /HbbTV/i,        // Hybrid Broadcast Broadband TV
    /BRAVIA/i,       // Sony
    /Viera/i,        // Panasonic
    /NetTV/i,        // Philips
    /Inettv/i,       // TV con navegador integrado
    /TV/i,           // Genérico que incluya "TV"
  ];

  const isTVUA = tvPatterns.some(pattern => pattern.test(ua));

  // También detectar por resolución de pantalla grande (Full HD o superior)
  const isLargeScreen = window.innerWidth >= 1920;

  // Considerar TV si cumple cualquiera de las dos condiciones
  return isTVUA || isLargeScreen;
};

/**
 * Obtiene información sobre el dispositivo para debugging
 */
export const getTVInfo = () => {
  const ua = navigator.userAgent;
  const info = {
    userAgent: ua,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    isTV: detectTV(),
    detectedBrand: null
  };

  // Detectar marca específica
  if (/Tizen/i.test(ua)) info.detectedBrand = 'Samsung';
  else if (/Web0S|WebOS|NetCast/i.test(ua)) info.detectedBrand = 'LG';
  else if (/BRAVIA/i.test(ua)) info.detectedBrand = 'Sony';
  else if (/Viera/i.test(ua)) info.detectedBrand = 'Panasonic';
  else if (/NetTV/i.test(ua)) info.detectedBrand = 'Philips';
  else if (/AppleTV/i.test(ua)) info.detectedBrand = 'Apple TV';

  return info;
};

const tvDetector = { detectTV, getTVInfo };
export default tvDetector;
